"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var useDebounce_1 = __importDefault(require("./useDebounce"));
exports.useDebounce = useDebounce_1["default"];
var useInView_1 = __importDefault(require("./useInView"));
exports.useInView = useInView_1["default"];
